import { types, actions } from './requests'
export const GETPRODUCTIONLIST_TYPES = {
    ...types('GETPRODUCTIONLIST'),
}
export const GETPRODUCTIONLIST_ACTIONS = {
    ...actions('GETPRODUCTIONLIST'),
}